import {SuccessfulApiResponse} from "@eryxcoop/appyx-comm";

export default class EditCurrentAccountRiskClassificationResponse extends SuccessfulApiResponse {
    static defaultResponse() {
        return {
            object: {
                "customer": {
                    "code": "123",
                    "fantasy_name": "Client123",
                    "business_name": "Client123BN123",
                    "number": "1234",
                    "taxpayer_identification_number": 123,
                    "delivery_sites": []
                },
                "outstanding_balance": {"amount": 10000.00, "currency": "ARS"},
                "overdue_balance": {"amount": 2500.00, "currency": "ARS"},
                "unassigned_balance": {"amount": 0.00, "currency": "ARS"},
                "total_balance": {"amount": 12500.00, "currency": "ARS"},
                "has_no_overdue_tolerance": true
            },
            errors: []
        }
    }

    isHighRisk() {
        return this.content().has_no_overdue_tolerance;
    }
}
